import createRefresh from "react-auth-kit/createRefresh";
import { authService } from "../api/services/authService";

interface RefreshParams {
  refreshToken?: string;
}

const refresh = createRefresh({
  interval: 10,
  refreshApiCallback: async (param: RefreshParams) => {
    try {
      const response = await authService.refreshToken(
        param?.refreshToken || ""
      );
      console.log("Renovando token de acceso");

      return {
        isSuccess: true,
        newAuthToken: response.access,
        newRefreshToken: response.refresh,
        newAuthTokenExpireIn: 10,
        newRefreshTokenExpiresIn: 60,
      };
    } catch (error) {
      console.error("Error al renovar token:", error);
      return {
        isSuccess: false,
        newAuthToken: "",
        newRefreshToken: "",
        newAuthTokenExpireIn: 0,
        newRefreshTokenExpiresIn: 0,
      };
    }
  },
});

export default refresh;
